module.exports = __webpack_public_path__ + "img/glasses-scene2.d52e03f8.png";